import { Roboto_Condensed } from 'next/font/google'

const roboto = Roboto_Condensed({ weight: ['400', '500'], subsets: ['latin'] })

export type ThemeProps = Partial<{}>

const Theme = ({}: ThemeProps) => {
  return (
    <style jsx global>{`
      :root {
        --font-family-helvetica: 'Helvetica Neue';
        --font-family-roboto: ${roboto.style.fontFamily};
        --font-size: 10px;
      }
    `}</style>
  )
}

export default Theme
